export var pad = function pad(number) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return "000".concat(number).slice(length * -1);
};

var _int = function _int(bool) {
  return bool === true ? 1 : 0;
};

export { _int as int };
export function debounce(fn, wait) {
  var t;
  return function () {
    var _arguments = arguments,
        _this = this;

    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, _arguments);
    }, wait);
  };
}
export var arrayify = function arrayify(obj) {
  return obj instanceof Array ? obj : [obj];
};